import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export class SelectField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focus: false
    };
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    inputRef: PropTypes.func,
    className: PropTypes.array,
    disabled: PropTypes.bool,
    options: PropTypes.array,
    emptyVal: PropTypes.string,
    required: PropTypes.bool
  };

  static defaultProps = {
    label: null,
    inputRef: () => null,
    className: [],
    disabled: false,
    emptyVal: "Velg",
    required: false
  };

  onFocus() {
    this.setState({
      focus: true
    });
  }

  onBlur() {
    this.setState({
      focus: false
    });
  }

  render() {
    const {
      id,
      name,
      label,
      value,
      onChange,
      inputRef,
      disabled,
      options,
      emptyVal,
      required,
      className
    } = this.props;
    const hasLabel = !!label;
    const classes = ["input-field", "select-input"];
    //className.push("input-field");
    //className.push("select-input");
    if (hasLabel) {
      classes.push("input-field-label");
    }

    classes.push(className);

    let empty;
    if (!value) {
      empty = <option value="">{emptyVal}</option>;
    }

    return (
      <div
        className={classNames(classes, {
          disabled: disabled,
          focus: this.state.focus
        })}
      >
        {hasLabel && <label htmlFor={id}>{label}</label>}
        <select
          ref={inputRef}
          id={id}
          name={name}
          value={value}
          disabled={disabled}
          onChange={onChange}
          required={required}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
        >
          {empty}
          {options.map((item, i) => (
            <option key={i} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

export default SelectField;
